import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../fragments/button';
import {FormInline} from '../../../fragments/forms';

export default class ContinueButton extends React.Component {

  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
  };

  render() {
    const {
      onSubmit,
    } = this.props;

    return (
      <FormInline dom="div">
        <Button
         btnStyle="primary"
         pullRight
         type="submit"
         onClick={
          onSubmit}>
          Continue
        </Button>
      </FormInline>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/wizard/susc-results/gtable/continue-button.js